module.exports = __webpack_public_path__ + "static/patient-web-circle-681a6321ae0a92f3969644a46b2a9fb1.webp";